export const typeInvoiceLog = [
    { id: 1, name: 'Member' },
    { id: 2, name: 'Scan QR' },
    { id: 3, name: 'Service' },
    { id: 4, name: 'Agency' },
]


// WEBPACK FOOTER //
// ./src/constant/TypeInvoiceLog.js